<template>
    <div>
        <span @click="search()">
            <Button type="primary" @click="modal = true" v-hasPermission="['cases:case:add']">{{ $t('ticket.list.addTicket') }}</Button>
        </span>
        <Modal v-model="modal" :title="$t('ticket.list.addTicket')" :loading="loading" :mask-closable="false" :styles="{top:'65px'}">
            <Form ref="caseForm" :model="caseForm" :label-width="100" :rules="ruleValidate">
                <!-- 问题类型 -->
                <FormItem :label="$t('ticket.list.category')" prop="ticketCategory">
                    <Select v-model="caseForm.ticketCategory" filterable style="width:300px;" @on-change="changeTicketCategory" placeholder=" ">
                      <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in ticketCategoryList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 功能类型 -->
                <FormItem :label="$t('satisfaction.functionCategory')" prop="functionType">
                    <Select v-model="caseForm.functionType" filterable style="width:300px;" @on-change="changeFunctionType" placeholder=" ">
                       <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in functionTypeList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 概要 -->
                <FormItem :label="$t('satisfaction.summary')" prop="outline">
                    <Input v-model="caseForm.outline" placeholder="" style="width:300px;"></Input>
                </FormItem>

                <!-- 状态 -->
                <FormItem :label="$t('satisfaction.status')" prop="status">
                    <Select v-model="caseForm.status" filterable style="width:300px;" placeholder=" ">
                      <Option value="0">{{ $t('ticket.list.Pending') }}</Option>
                      <Option value="1">{{ $t('ticket.list.Processing') }}</Option>
                      <Option value="2">{{ $t('ticket.list.Finish') }}</Option>
                      <Option value="3">{{ $t('ticket.list.WaitingForTheAuthorization') }}</Option>
                      <Option value="4" disabled>{{ $t('ticket.list.CheckNozzle') }}</Option>
                      <Option value="5">{{ $t('ticket.list.UnderReview') }}</Option>
                      <Option value="6">{{ $t('ticket.list.TheAuditFails') }}</Option>
                      <Option value="7">{{ $t('ticket.list.Approved') }}</Option>
                      <Option value="8">{{ $t('ticket.list.Confirming') }}</Option>
                      <Option value="9">{{ $t('ticket.list.Confirmed') }}</Option>
                    </Select>
                </FormItem>

                <!-- 监控模块 -->
                <FormItem :label="$t('ticket.list.monitorModule')" prop="monitorModule">
                    <Select v-model="caseForm.monitorModule" filterable style="width:300px;" placeholder=" ">
                        <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in monitorModuleList" :key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 审批流 -->
                <FormItem :label="$t('approvalFlowConfigManagement.approvalFlow.title')" prop="approvalFlow">
                    <Select v-model="caseForm.approvalFlow" filterable style="width:300px;" @on-change="changeApprovalFlow" placeholder=" ">
                         <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="(item,index) in approvalFlowList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 优先级 -->
                <FormItem :label="$t('ticket.list.level')" prop="priority">
                    <Select v-model="caseForm.priority" filterable style="width:300px;" placeholder=" ">
                        <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                        <Option :value="item.id" v-for="item in priorityList" v-bind:key="item.id">{{item.name}}</Option>
                    </Select>
                </FormItem>

                <!-- 经办人 -->
                <FormItem :label="$t('ticket.list.assignee')" prop="agent">
                    <Select v-model="caseForm.agent" filterable style="width:300px;" placeholder=" ">
                        <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                        <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </FormItem>

                <!-- 确认人 （“变更请求”和“定时任务管理”需要加“确认人”字段（必填）；） -->
                <div v-if="caseForm.ticketCategory == 5 || caseForm.ticketCategory == 6">
                    <FormItem :label="$t('ticket.list.confirmMan')" prop="confirmMan">
                        <Select v-model="caseForm.confirmMan" filterable style="width:300px;" placeholder=" ">
                            <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                            <Option v-for="item in agentList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 公司 -->
                <div v-if="companyIdCookie==1">
                    <FormItem :label="$t('LabelConfig.LabelSynchronization.company')" prop="companyId">
                        <Select v-model="caseForm.companyId" filterable style="width:300px;" placeholder=" ">
                            <Option value="">{{ $t('configuration_management.common.all') }}</Option>
                            <Option :value="item.id" v-for="(item,index) in companyIdList" v-bind:key="index">{{item.companyName}}</Option>
                        </Select>
                    </FormItem>
                </div>

                <!-- 附件 -->
                <FormItem :label="$t('LabelConfig.LabelSynchronization.attachment')" prop="enclosure">
                    <Upload  ref="upload" v-model="caseForm.enclosure" :on-success="uploadSuccess" :on-error="uploadError" :headers='{"userName": userName}' multiple type="drag" :action="actionUrl" style="width:300px;" :show-upload-list="true" :on-remove="handleRemove">
                        <div>
                            <Icon type="ios-cloud-upload" size="50" style="color: #3399ff"></Icon>
                            <p>{{ $t('message.uploadFile')}}</p>
                        </div>
                    </Upload>
                </FormItem>

                <!-- 描述 -->
                <FormItem :label="$t('ticket.list.description')" prop="describe">
                    <Input v-model="caseForm.describe" type="textarea" :autosize="{minRows: 2,maxRows: 5}" placeholder="" style="width:300px;"></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="caseReset('caseForm')">{{ $t('ticket.list.cancel') }}</Button>
                <Button type="primary" @click="caseSubmit('caseForm')">{{ $t('common.ok') }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    import {setCookie,getCookie} from '../../../utils/cookieUtil.js'
    import TableCase from '../case/TableCase.vue'
    var tableCase = TableCase;
    export default {
        data () {
            return {
                companyIdCookie:getCookie(global.companyId),
                showDetermineName:this.$t('common.determine'),
                agentList:[],
                userName:getCookie(global.cookieName),
                actionUrl:'',
                caseForm: {
                    ticketCategory: '',
                    outline: '',
                    describe: '',
                    priority: '',
                    enclosure: '',
                    agent: '',
                    status:'',
                    monitorModule:'',
                    approvalFlow:'',
                    functionType:'',
    				confirmMan: '',
                    companyId:''
                },
                companyIdList:[],
                approvalFlowList:[],
                attachmentIDs:[],
                // 监控模块
                monitorModuleList: [],
                // 问题类型
                ticketCategoryList: [],
                // 功能类型
                functionTypeList:[],
                // 优先级别
                priorityList: [],
                loading: true,
                modal:false,
                ruleValidate: {
                    ticketCategory: [
                        { required: true, message: this.$t('ticket.list.selectProblemType'), trigger: 'change',type:'number'  }
                    ],
                    functionType: [
                        { required: true, message: this.$t('ticket.list.selectFunctionType'), trigger: 'change',type:'number'  }
                    ],
                    companyId: [
                        {required: true, message: this.$t('ticket.list.selectCompany'), trigger: 'change', type: 'number'}
                    ],
                    approvalFlow: [
                        { required: false, message: this.$t('ticket.list.selectApprovalFlow'), trigger: 'change', type: 'number' }
                    ],
                    outline: [
                        { required: true, message: this.$t('ticket.list.summaryRequired'), trigger: 'blur' }
                    ],
                    describe: [
                        { required: true, message: this.$t('common.descriptionRequired'), trigger: 'blur'}
                    ],
                    priority: [
                        { required: true, message: this.$t('ticket.list.selectPriority'), trigger: 'change',type:'number'  }
                    ],
                    status: [
                        { required: true, message: this.$t('ticket.list.selectStatus'), trigger: 'change',type:'string' }
                    ],
                    agent: [
                        { required: true, message: this.$t('ticket.list.selectAssignee'), trigger: 'change',type:'number' }
                    ],
                    confirmMan: [
                        {  required: true, message: this.$t('ticket.list.selectConfirmMan'), trigger: 'change',type:'number' }
                    ],
                    monitorModule: [
                        { required: true, message: this.$t('ticket.list.selectMonitorIndex'), trigger: 'change',type:'number' }
                    ]
                }
            }
        },
        mounted:function(){
            // 上传附件接口
            this.actionUrl=process.env.API_ROOT+'/sme/file/uploadFileS3';
        },
        methods:{
            // 公司列表
            listRegisterInformation: function () {
                this.$api.user.listRegisterInformation()
                .then(res => {
                    // 获取公司列表数据
                    this.companyIdList = res.data.companies;
                })
            },
            // 审批流
            selectListNames:function(){
                this.$api.processTemplate.selectListNames({
                    "type":0
                })
                .then(res => {
                    this.approvalFlowList = res.data;
                })
            },
            // 第一次点击“添加案例”时， 查询问题类型、功能类型、状态、优先级等下拉选值列表
            getProblemType:function(){
                this.$api.ticket.getProblemType({})
                .then(res => {
                    // 问题类型
                    this.ticketCategoryList = res.data.problemTypeList;
                    // 功能类型
                    this.functionTypeList=res.data.functionTypeList;
                    // 优先级
                    this.priorityList=res.data.priorityLevelList;

                    // 设置默认值
                    this.caseForm.ticketCategory = this.ticketCategoryList[0].id;
                    this.caseForm.functionType = this.functionTypeList[0].id;
                    this.caseForm.priority = this.priorityList[0].id;

                })
            },
            // 切换问题类型
            changeTicketCategory:function(){
                if(this.caseForm.ticketCategory==undefined){
                    return;
                }
                this.$api.ticket.getProblemType({
                    "index":this.caseForm.ticketCategory
                })
                .then(res => {
                    // 功能类型
                    this.functionTypeList=res.data.functionTypeList;
                    this.caseForm.functionType=this.functionTypeList[0].id;
                    // 优先级
                    this.priorityList=res.data.priorityLevelList;
                    this.caseForm.priority = res.data.priorityId;
                })
            },
            // 切换功能类型
            changeFunctionType:function(){
                if(this.caseForm.functionType==undefined){
                    return;
                }
                // 优先级
                this.$api.ticket.getProblemType({
                    "index":this.caseForm.ticketCategory,
                    "functionIndex":this.caseForm.functionType
                })
                .then(res => {
                    // 优先级
                    this.priorityList=res.data.priorityLevelList;
                    this.caseForm.priority = res.data.priorityId;
                })
            },
            // 切换审批流
            changeApprovalFlow:function(){
                // 如果不选审批流 显示确定 否则显示提交
                if(this.caseForm.approvalFlow==''){
                    this.showDetermineName=this.$t('common.determine')
                }else{
                    this.showDetermineName=this.$t('common.submit')
                }
            },
            // 查询监控模块
            searchMonitorModule: function(){
                this.$api.alertRule.searchMonitorModule("userName",getCookie(global.cookieName))
                .then(res => {
                    this.monitorModuleList = res.data;
                })
            },
            // 附件
            /****************************************************/
            // 上传成功
            uploadSuccess (res, file,fileList) {
                this.$Message.success(this.$t('common.uploadSuccess'));
                this.attachmentIDs.push(file.response.id);
            },
            // 上传失败
            uploadError(error, file) { //上传失败
                this.$Message.error(this.$t('common.uploadFail'));
            },
            // 删除附件
            handleRemove(file,fileList){
                this.$api.file.deleteAttatchment("id",file.response.id)
                .then(res => {
                    this.$Message.success(this.$t('common.deleteSuccess'));
                    this.attachmentIDs=[];
                    for(var i=0;i<fileList.length;i++){
                        this.attachmentIDs.push(fileList[i].response.id)
                    }
                })
            },
            // 查询近经办人
            search: function(){
                this.showDetermineName=this.$t('common.determine');
                this.selectListNames();
                this.getProblemType();
                this.listRegisterInformation();
                this.$api.user.selectAgent("userName",getCookie(global.cookieName))
                .then(res => {
                    this.agentList = res.data;
                })
                this.searchMonitorModule();
            },
            caseSubmit: function(name){
                this.$refs[name].validate(valid => {
                    if(valid){
                        // 添加案例
                        this.$api.ticket.createTicket({
                            "ticketCategory":this.caseForm.ticketCategory,
                            "subject":this.caseForm.outline,
                            "status":this.caseForm.status,
                            "monitorModule":this.caseForm.monitorModule,
                            "priorityId":this.caseForm.priority,
                            "assigneeUserId":this.caseForm.agent,
                            "description":this.caseForm.describe,
                            "attachmentIDs":this.attachmentIDs,
                            "functionType":this.caseForm.functionType,
                            "processTemplateId":this.caseForm.approvalFlow,
                            "companyId":this.caseForm.companyId
                        })
                        .then(res => {
                            this.data = res.data;
                            setTimeout(() => {
                                tableCase.methods.showAll();
                                this.$refs[name].resetFields();
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success(this.$t('common.addSuccess'));
                                this.$refs.upload.clearFiles();
                                this.attachmentIDs=[];
                                this.modal = false;
                            },1000);
                        })
                    }else{
                        //解决iview 表单验证，验证提示error完成验证后，"确定"按钮一直转圈，点击不起作用问题
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error(this.$t('common.addFail'));
                    }
                });
            },
            caseReset: function(name){
                this.modal = false;
                if(this.attachmentIDs.length>0){
                    // 删除所有附件
                    this.$api.file.deleteByAttachmentIDs({
                        "attachmentIDs":this.attachmentIDs
                    })
                    .then(res => {
                        this.$refs.upload.clearFiles();
                        this.attachmentIDs=[];
                    })
                }else{
                    this.$refs.upload.clearFiles();
                    this.attachmentIDs=[];
                }
                this.$refs[name].resetFields();
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/cases/case/AddCase.vue